/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Products_Menu_Analytics_DescInputs */



/**
* | output |
* | --- |
* | "Who joins, stays and talks, charted by the hour" |
*
* @param {Products_Menu_Analytics_DescInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const products_menu_analytics_desc = /** @type {((inputs?: Products_Menu_Analytics_DescInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Products_Menu_Analytics_DescInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Кто приходит, остаётся и общается — по часам")
	return /** @type {LocalizedString} */ ("Who joins, stays and talks, charted by the hour")
});